import Cookies from 'js-cookie';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, H1, FormGroup, InputGroup, Toaster } from '@blueprintjs/core';

import {  FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, 
          FRONT_USER_ROLE_COOKIE_NAME, 
          FRONT_USER_PASSWORD_IN_COOKIE_NAME,
          FRONT_USER_FIRST_NAME_COOKIE_NAME,
          FRONT_USER_LAST_NAME_COOKIE_NAME,
          FRONT_USER_AFFILIATION_COOKIE_NAME,
          FRONT_USER_STATUS_COOKIE_NAME,
          FRONT_USER_EMAIL_COOKIE_NAME,
          FRONT_USER_COUNTRY_COOKIE_NAME,
        } from './constants';
import './CommonAuth.css';
import { ANALYTICS_URL, SIGNUP_URL } from '../constants';


class SignIn extends React.PureComponent {

  refHandlers = {
    toaster: (ref) => this.toaster = ref,
  };

  state = {
    login: Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME)?Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME):'',
    password: Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME)?Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME):'',
  };



  componentDidMount() {

    // si on a des user et mdp en cookie, on les place dans l'état de la page et on lance le signIn() 
    if (  Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME) 
        && Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME) 
        && Cookies.get(FRONT_USER_ROLE_COOKIE_NAME) ) {

        this.signIn();
        return;

        // var url=window.location.href;
        // var param="";
        // if (url.match(/signin(\?.+)/)) {
        //   param=RegExp.$1;
        // }
        // // redirect to corpus type choice when succeed
        // this.props.history.push(ANALYTICS_URL+param);
        // // without a proper global state, that's the best way to
        // // let the entire app knows the auth state has changed
        // //window.location.reload(); /// A quoi sert ce reload ???
        // return;
    }
    
    // check if the user reaches this page from the signup email,
    // if yes show a message
    const urlParams = new URLSearchParams(window.location.search);
    const signUpSuccess = urlParams.get('success');
    if (signUpSuccess) {
      this.addSignUpSuccessToast();
    } 
  }

  addCredentialsErrorToast = () => {
    this.toaster.show({
      message: this.props.t('credentialsErrorsMsg'),
      intent: 'danger',
      icon: 'warning-sign',
    });
  }

  addSignUpSuccessToast = () => {
    this.toaster.show({
      message: this.props.t('successfulSignupMsg'),
      intent: 'success',
      icon: 'tick',
    });
  }

  signIn = (e) => {
    if (e) { e.preventDefault();}
    
    const { login, password } = this.state;

    if (login === '' || password === '') {
      return;
    }

    const endpoint = '/signIn.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS, 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, password })
    })
    .then((res) => {
      if (res.status === 401) {
        this.addCredentialsErrorToast();
      } else if (res.status !== 200) {
        console.log(`Error when trying to connect with ${endpoint}`);
      } else {
        res.json().then((data) => {
          // set front-end specific cookie, expire at the end of session (like the backend session cookie)
          // allow to reopen the user session later without login form
          Cookies.set(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, login);
          Cookies.set(FRONT_USER_PASSWORD_IN_COOKIE_NAME, password);
          Cookies.set(FRONT_USER_ROLE_COOKIE_NAME, data['role']);          
          Cookies.set(FRONT_USER_FIRST_NAME_COOKIE_NAME, data['prenom']);
          Cookies.set(FRONT_USER_LAST_NAME_COOKIE_NAME, data['nom']);
          Cookies.set(FRONT_USER_EMAIL_COOKIE_NAME, data['email']);
          Cookies.set(FRONT_USER_AFFILIATION_COOKIE_NAME, data['affiliation']);
          Cookies.set(FRONT_USER_STATUS_COOKIE_NAME, data['statut']);
          Cookies.set(FRONT_USER_COUNTRY_COOKIE_NAME, data['pays']);
          var url=window.location.href;
          var param="";
          if (url.match(/signin(\?.+)/)) {
            param=RegExp.$1;
          }
          // redirect to corpus type choice when succeed
          this.props.history.push(ANALYTICS_URL+param);
          // without a proper global state, that's the best way to
          // let the entire app knows the auth state has changed
          // window.location.reload();
        })
      }
    })
    .catch(() => {
      console.log(`Network error when trying to fetch ${endpoint}`);
    })
  }

  onTextUpdate = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    this.setState({ [id]: value });
  }
  goToSignUp = () => {
    this.props.history.push(SIGNUP_URL);
  }


  render() {
    const { t } = this.props;
    const { login, password } = this.state;

    return (
      <>
        <div className="CommonAuth__wrapper SignIn__form">
          <H1>{t('signIn')}</H1>

          <form onSubmit={this.signIn}>
            <FormGroup label={t('logIn')} labelFor="login">
              <InputGroup id="login" type="text" value={login} onChange={this.onTextUpdate} />
            </FormGroup>

            <FormGroup label={t('password')} labelFor="password" >
              <InputGroup id="password" type="password" value={password} onChange={this.onTextUpdate} />
            </FormGroup>

            <Button type="submit" intent='primary'>Ok</Button>
          </form>
          <br/><br/>
          <div>
          <Button text={t('signUp')} onClick={this.goToSignUp} />
          </div>
        </div>
        {/* Special component, out of the normal flow */}
        <Toaster ref={this.refHandlers.toaster} />
      </>
    );
  }
}

export default withTranslation()(SignIn);
